<template>
  <div class="container">
    <h2 class="text-center">{{ title }} Students</h2>
    <div class="row mt-20 mb-20">
      <div class="d-flex">
        <select name="session"
                id="session"
                class="form-control ml-20 mr-20 w-auto"
                @change="onChangeSession"
                :value="session"
        >
          <option value="">All</option>
        </select>
      </div>
      <FormElementWithoutLabel>
        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success ml-15">
          <input
              id="branch-wise"
              type="checkbox"
              v-model="branchWise"
          >
          <label for="branch-wise" class="pl-20 pt-10">
            Branch-Wise
          </label>
        </div>
      </FormElementWithoutLabel>
      <FormElementWithoutLabel>
        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success ml-15">
          <input
              id="shift-wise"
              type="checkbox"
              v-model="shiftWise"
          >
          <label for="shift-wise" class="pl-20 pt-10">
            Shift-Wise
          </label>
        </div>
      </FormElementWithoutLabel>
      <FormElementWithoutLabel>
        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success ml-15">
          <input
              id="class-wise"
              type="checkbox"
              v-model="classWise"
          >
          <label for="class-wise" class="pl-20 pt-10">
            Class-Wise
          </label>
        </div>
      </FormElementWithoutLabel>
      <FormElementWithoutLabel>
        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success ml-15">
          <input
              id="section-wise"
              type="checkbox"
              v-model="sectionWise"
          >
          <label for="section-wise" class="pl-20 pt-10">
            Section-Wise
          </label>
        </div>
      </FormElementWithoutLabel>
      <FormElementWithoutLabel>
        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success ml-15">
          <input
              id="transpose-branch-class"
              type="checkbox"
              v-model="branchDirectionTowardRow"
          >
          <label for="transpose-branch-class" class="pl-20 pt-10">
            Transpose Branch-Class
          </label>
        </div>
      </FormElementWithoutLabel>
    </div>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th v-if="shiftWise" :rowspan="(sectionWise || type !== 'total') ? 2 : 1">Shifts</th>
          <th v-if="branchDirectionTowardRow && branchWise" :rowspan="(sectionWise || type !== 'total') ? 2 : 1"> Branches </th>
          <th v-if="!branchDirectionTowardRow && classWise" :rowspan="(sectionWise || type !== 'total') ? 2 : 1"> Classes </th>
          <th v-if="branchWise && !branchDirectionTowardRow" v-for="branch in branches">
            {{ branch.name }}
          </th>
          <th v-if="classWise && branchDirectionTowardRow" v-for="clazz in classes">
            {{ clazz.name }}
          </th>
          <th v-if="(!sectionWise && type === 'total') || (branchWise && !branchDirectionTowardRow) || (classWise && branchDirectionTowardRow)"
              :rowspan="(sectionWise || type !== 'total') ? 2 : 1"
          >
            Total
          </th>
        </tr>
        <tr v-if="sectionWise || type !== 'total'">
          <th v-if="branchWise && !branchDirectionTowardRow" v-for="branch in branches">
            <div class="d-flex justify-content-between align-items-end">
              <div v-if="sectionWise">Section</div>
              <div v-if="genderWise">Male</div>
              <div v-if="genderWise">Female</div>
              <div v-if="groupWise">Science</div>
              <div v-if="groupWise">Business</div>
              <div v-if="groupWise">Humanities</div>
              <div v-if="residentialStatusWise">Resident</div>
              <div v-if="residentialStatusWise">Non-Resident</div>
              <div v-if="residentialStatusWise">VIP Resident</div>
              <div v-if="residentialStatusWise">Day-Care</div>
              <div v-if="locationWise" v-for="location in distinctValues({}, 'location')">{{location.name ?? 'Unknown'}}</div>
              <div v-if="religionWise" v-for="religion in distinctValues({}, 'religion')">{{religion.name ?? 'Unknown'}}</div>
              <div v-if="hifzGroupWise" v-for="hifzGroup in distinctValues({}, 'hifz_group')">{{hifzGroup.name ?? 'Unknown'}}</div>
              <div>Total</div>
            </div>
          </th>
          <th v-else-if="classWise && branchDirectionTowardRow" v-for="clazz in classes">
            <div class="d-flex justify-content-between align-items-end">
              <div v-if="sectionWise">Section</div>
              <div v-if="genderWise">Male</div>
              <div v-if="genderWise">Female</div>
              <div v-if="groupWise">Science</div>
              <div v-if="groupWise">Business</div>
              <div v-if="groupWise">Humanities</div>
              <div v-if="residentialStatusWise">Resident</div>
              <div v-if="residentialStatusWise">Non-Resident</div>
              <div v-if="residentialStatusWise">VIP Resident</div>
              <div v-if="residentialStatusWise">Day-Care</div>
              <div v-if="locationWise" v-for="location in distinctValues({}, 'location')">{{location.name ?? 'Unknown'}}</div>
              <div v-if="religionWise" v-for="religion in distinctValues({}, 'religion')">{{religion.name ?? 'Unknown'}}</div>
              <div v-if="hifzGroupWise" v-for="hifzGroup in distinctValues({}, 'hifz_group')">{{hifzGroup.name ?? 'Unknown'}}</div>
              <div>Total</div>
            </div>
          </th>
          <th v-else-if="sectionWise || type !== 'total'">
            <div class="d-flex justify-content-between align-items-end">
              <div v-if="sectionWise">Section</div>
              <div v-if="genderWise">Male</div>
              <div v-if="genderWise">Female</div>
              <div v-if="groupWise">Science</div>
              <div v-if="groupWise">Business</div>
              <div v-if="groupWise">Humanities</div>
              <div v-if="residentialStatusWise">Resident</div>
              <div v-if="residentialStatusWise">Non-Resident</div>
              <div v-if="residentialStatusWise">VIP Resident</div>
              <div v-if="residentialStatusWise">Day-Care</div>
              <div v-if="locationWise" v-for="location in distinctValues({}, 'location')">{{location.name ?? 'Unknown'}}</div>
              <div v-if="religionWise" v-for="religion in distinctValues({}, 'religion')">{{religion.name ?? 'Unknown'}}</div>
              <div v-if="hifzGroupWise" v-for="hifzGroup in distinctValues({}, 'hifz_group')">{{hifzGroup.name ?? 'Unknown'}}</div>
              <div>Total</div>
            </div>
          </th>
          <th v-if="sectionWise && type === 'total' && !((branchWise && !branchDirectionTowardRow) || (classWise && branchDirectionTowardRow))">Total</th>
        </tr>
      </thead>
      <tbody>

        <!-- Shift-Wise-->
        <ShiftWise v-if="shiftWise"
            :type="type"
            :session="session"
            :student-counts="studentCounts"
            :branches="branches"
            :classes="classes"
            :shifts="shifts"
            :classWise="classWise"
            :branch-wise="branchWise"
            :section-wise="sectionWise"
            :branch-direction-toward-row="branchDirectionTowardRow"
        />

        <!-- Not Shift Wise -->
        <WithoutShift v-else
            :type="type"
            :session="session"
            :student-counts="studentCounts"
            :branches="branches"
            :classes="classes"
            :shifts="shifts"
            :classWise="classWise"
            :branch-wise="branchWise"
            :section-wise="sectionWise"
            :branch-direction-toward-row="branchDirectionTowardRow"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import FormElementWithoutLabel from "../../components/FormElementWithoutLabel.vue";
import {ref} from "vue";
import ShiftWise from "./ShiftWise.vue";
import WithoutShift from "./WithoutShift.vue";

export default {
  components: {WithoutShift, FormElementWithoutLabel, ShiftWise},
  props: {
    students: Array,
    type: String,
    title: String,
  },
  setup(props) {
    let students = collect(props.students).sortBy(['shift', 'class', 'branch', 'section']);
    if (props.type === 'group_wise') {
      students = students.filter((item) => !!item.group_name);
    }

    const branches = students.map((item) => {
      return {
        id: item.branch_id,
        name: item.branch,
      }
    }).unique('id');
    const classes = students.map((item) => {
      return {
        id: item.class_id,
        name: item.class,
      }
    }).unique('id');
    const shifts = students.map((item) => {
      return {
        id: item.shift_id,
        name: item.shift,
      }
    }).unique('id');

    return {
      session: ref(Number(new URL(window.location.href).searchParams.get('session'))),
      studentCounts: ref(students),
      branches: ref(branches),
      classes: ref(classes),
      shifts: ref(shifts),
      shiftWise: ref(true),
      classWise: ref(true),
      branchWise: ref(true),
      sectionWise: ref(true),
      genderWise: ref(props.type === 'gender_wise'),
      religionWise: ref(props.type === 'religion_wise'),
      groupWise: ref(props.type === 'group_wise'),
      residentialStatusWise: ref(props.type === 'residential_status_wise'),
      hifzGroupWise: ref(props.type === 'hifz_group_wise'),
      locationWise: ref(props.type === 'location_wise'),
      branchDirectionTowardRow: ref(false),
    };
  },
  methods: {
    studentsFilteredBy(filter) {
      if (this.session) {
        filter['session_id'] = this.session;
      }

      return this.studentCounts.filter((count) => {
        return Object.keys(filter).every(key => count[key] === filter[key]);
      });
    },
    distinctValues(filter, valueKey) {
      return this.studentsFilteredBy(filter)
          .map((count) => { return {id: count[valueKey+'_id'] ?? count[valueKey], name: count[valueKey]} }).unique('id');
    },
    onChangeSession(event) {
      this.session = Number(event.target.value);
      fetch(
          `${route('students.summary_data')}?type=${this.type}&session=${event.target.value}`,
          {
            method: 'get',
            headers: new Headers({
              'X-Requested-With': 'XMLHttpRequest',
            }),
            credentials: 'include'  // adds cookie header
          }
      ).then(async response => {
        if (response.status === 422) {
          console.error('error in fetching summary', response)
        } else if (!response.ok) {
          const error = await response.text()
          toastr.error(`Failed fetching student count summary: ${error}`)
        } else {
          let students = await response.json();
          students = collect(students).sortBy(['shift', 'class', 'branch', 'section']);

          this.branches = students.map((item) => {
            return {
              id: item.branch_id,
              name: item.branch,
            }
          }).unique('id');

          this.classes = students.map((item) => {
            return {
              id: item.class_id,
              name: item.class,
            }
          }).unique('id');

          this.shifts = students.map((item) => {
            return {
              id: item.shift_id,
              name: item.shift,
            }
          }).unique('id');

          this.studentCounts = students;
        }
      })
    },
  },
}
</script>

<style scoped>
.table th div{
  padding: 0.5rem;
}
</style>